import React, { useState } from 'react'
import * as Yup from 'yup';
import { Modal, Row } from 'antd'
import { Button, FormSubmitButton, FormTextArea, MasterDetailForm, Widget } from '@digital/ui'
import { Visibility } from '@app/components';
import { ordemCompraIdState } from '../atoms'
import { useRecoilValue } from 'recoil';
import { aprovarRelatorioHomologacao } from '@app/api/sas/relatorioHomologacao';

const ModalReenviarAprovacaoRelatorioHomologacao = ({ onReloadRelatorio }: any) => {
    const [exibirModal, setExibirModal] = useState(false)
    const ordemCompraId = useRecoilValue(ordemCompraIdState)

    const onCancel = () => {
        setExibirModal(false)
    }

    const onSubmit = async (values: any) => {
        const result = await aprovarRelatorioHomologacao(ordemCompraId, values.justificativa)
        if (result && result.valid) {
            setExibirModal(false)
            onReloadRelatorio()
        }
    }

    return (
        <>
            <Button title='Reenviar aprovação' style={{ marginRight: '10px' }} onClick={() => setExibirModal(true)} type='primary' />
            <Visibility visible={exibirModal} >
                <Modal
                    title='Reenviar para aprovação'
                    width='780px'
                    visible={exibirModal}
                    onCancel={onCancel}
                    footer={null}
                >
                    <MasterDetailForm
                        key="form-reenviar-aprovacao-relatorio-homologacao"
                        onSubmit={onSubmit}
                        validationSchema={Yup.object().shape({
                            justificativa: Yup.string().required('Campo obrigatário')
                        })}
                        actions={[
                            <Button title='Fechar' onClick={onCancel} type='link' />,
                            <FormSubmitButton noIcon type='primary' title='Enviar' />
                        ]}
                    >
                        <Widget>
                            <Row>
                                <FormTextArea name="justificativa" label='Justificativa' span={12} rows={3} />
                            </Row>
                        </Widget>
                    </MasterDetailForm>
                </Modal>
            </Visibility>
        </>
    )
}

export default ModalReenviarAprovacaoRelatorioHomologacao